import { render, staticRenderFns } from "./CredentialsCard.vue?vue&type=template&id=6dcf85e3&scoped=true&"
import script from "./CredentialsCard.vue?vue&type=script&lang=js&"
export * from "./CredentialsCard.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsCard.vue?vue&type=style&index=0&id=6dcf85e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcf85e3",
  null
  
)

export default component.exports